import moment from 'moment'

window.moment = moment

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vuetify from './plugins/vuetify'
import _ from 'lodash';
import ApiService from "./common/api.service"
import DateFilter from "./common/date.filter"
import ErrorFilter from "./common/error.filter"
import VueEasyLightbox from 'vue-easy-lightbox'
import { rtdbPlugin } from 'vuefire'

Vue.config.productionTip = false

Vue.filter("date", DateFilter);
Vue.filter("error", ErrorFilter);
Vue.use(_);
Vue.use(VueEasyLightbox);
Vue.use(rtdbPlugin);

const EventBus = new Vue();
export default EventBus;

ApiService.init();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
